var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaderHosLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 16,
    viewBox: "0 0 178 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_2962_1403)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.71645 0.225586V6.29116H3.3967V0.225586H0V15.7746H3.3967V9.04601H9.71645V15.7746H13.1132V0.225586H9.71645Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.593 7.93191C19.593 10.968 20.9395 13.263 23.7228 13.263C26.7428 13.263 27.8141 10.7582 27.8141 7.98772C27.8141 5.04535 26.5962 2.73476 23.6686 2.73476C20.7411 2.73476 19.593 4.9047 19.593 7.93191ZM31.3236 7.94754C31.3236 12.2763 28.6983 16 23.5965 16C18.4946 16 16.0858 12.4526 16.0858 7.99888C16.0858 3.54514 18.9345 0 23.8152 0C28.4118 0 31.3236 3.18794 31.3236 7.94754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M37.508 0.116211V9.3809C37.508 12.3635 39.0575 13.2475 40.7514 13.2475C42.6956 13.2475 43.9158 12.2027 43.9158 9.3809V0.116211H47.3147V9.21346C47.3147 14.5312 44.1706 15.8863 40.7063 15.8863C37.2419 15.8863 34.1046 14.4731 34.1046 9.2782V0.116211H37.508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M53.0232 11.22C53.3818 12.7805 54.5141 13.4659 56.332 13.4659C58.1498 13.4659 58.9212 12.756 58.9212 11.6174C58.9212 10.3516 58.1634 9.80243 55.4771 9.18404C51.2031 8.19059 50.1453 6.6502 50.1453 4.55169C50.143 1.84373 52.1932 0.00195312 55.9102 0.00195312C60.0828 0.00195312 61.7428 2.22101 61.9683 4.49588H58.5468C58.3822 3.53816 57.8476 2.50007 55.8222 2.50007C54.4442 2.50007 53.6119 3.06265 53.6119 4.16771C53.6119 5.27278 54.2795 5.68801 56.8169 6.27068C61.3864 7.33556 62.3878 9.01884 62.3878 11.2111C62.3878 14.0508 60.2181 15.9997 56.0658 15.9997C51.9135 15.9997 49.9784 14.0553 49.6017 11.2223H53.0255L53.0232 11.22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M64.8959 0.225586V15.7746H76.0784L76.4798 13.0198H68.1933V9.06834H75.7062V6.31349H68.1933V2.98043H76.0355V0.225586H64.8959Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M98.5043 11.22C98.8629 12.7805 99.9951 13.4659 101.813 13.4659C103.631 13.4659 104.402 12.756 104.402 11.6174C104.402 10.3516 103.644 9.80243 100.958 9.18404C96.6841 8.19059 95.6263 6.6502 95.6263 4.55169C95.6263 1.84373 97.6743 0.00195312 101.393 0.00195312C105.564 0.00195312 107.226 2.22101 107.452 4.49588H104.03C103.865 3.53816 103.331 2.50007 101.306 2.50007C99.9275 2.50007 99.0952 3.06265 99.0952 4.16771C99.0952 5.27278 99.7628 5.68801 102.3 6.27068C106.87 7.33556 107.871 9.01884 107.871 11.2111C107.871 14.0508 105.701 15.9997 101.549 15.9997C97.3969 15.9997 95.4617 14.0553 95.085 11.2223H98.5088L98.5043 11.22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M113.313 7.93191C113.313 10.968 114.66 13.263 117.443 13.263C120.463 13.263 121.535 10.7582 121.535 7.98772C121.535 5.04535 120.317 2.73476 117.389 2.73476C114.462 2.73476 113.313 4.9047 113.313 7.93191ZM125.044 7.94754C125.044 12.2763 122.419 16 117.317 16C112.215 16 109.806 12.4526 109.806 7.99888C109.806 3.54514 112.657 0 117.536 0C122.13 0 125.044 3.18794 125.044 7.94754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M141.349 10.9834C140.717 13.8834 138.507 15.9975 134.573 15.9975C129.591 15.9975 127.236 12.5082 127.236 8.08344C127.236 3.65871 129.668 0.00195312 134.738 0.00195312C138.922 0.00195312 140.949 2.4331 141.333 5.03167H137.936C137.607 3.83285 136.766 2.63848 134.63 2.63848C131.828 2.63848 130.748 5.13213 130.748 7.96289C130.748 10.5905 131.686 13.361 134.722 13.361C136.939 13.361 137.638 11.892 137.934 10.9834H141.351H141.349Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M147.362 0.225586H143.965V15.7746H147.362V0.225586Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M159.049 9.42776C157.933 6.14605 157.222 4.04978 156.844 2.65226H156.821C156.433 4.18596 155.65 6.6238 154.755 9.42776H159.049ZM154.042 12.1826L152.818 15.7746H149.477L154.811 0.225586H159.079L164.643 15.7746H161.073L159.78 12.1826H154.042Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M166.662 0.225586V15.7746H177.494L177.882 13.0198H170.058V0.225586H166.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M82.4049 7.2575C82.4049 8.31568 82.874 9.11937 83.8461 9.11937C84.9017 9.11937 85.2738 8.24648 85.2738 7.27759C85.2738 6.25066 84.8498 5.44475 83.8281 5.44475C82.8064 5.44475 82.4049 6.20155 82.4049 7.2575ZM86.4963 7.26197C86.4963 8.7711 85.5806 10.0726 83.7988 10.0726C82.017 10.0726 81.1779 8.83585 81.1779 7.27983C81.1779 5.72381 82.1726 4.48926 83.8755 4.48926C85.4791 4.48926 86.4963 5.60102 86.4963 7.26197Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M87.5316 4.56738H91.359V5.52957H88.6886V6.86011H91.1899V7.82007H88.6886V9.99448H87.5316V4.56738Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M91.359 11.082H81.1802V11.7339H91.359V11.082Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2962_1403"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 177.882,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderHosLogo);
export default __webpack_public_path__ + "static/media/header-hos-logo.c0a02ff979921307acf9a1a37c771c42.svg";
export { ForwardRef as ReactComponent };